import { AddCircle, Delete, Edit } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, IconButton, Tooltip } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { getDataWithResponse } from 'global/getFunc';
import { MaterialReactTable } from 'material-react-table';
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';
import Tambah from './Tambah';
import ArgonButton from 'components/ArgonButton';
import Swal from 'sweetalert2';
import { postDelete } from 'global/postFunc';
// import EditData from './EditData';

const Admin = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [updating, setUpdating] = useState(false)

    const reqAdminOpd = () => {
        setLoading(true)
        addReq()
        getDataWithResponse(
            '/sa/users/admin',
            decryptedUser,
            (res) => {
                setLoading(false)
                console.log(res);
                setData(res)
            },
            (res) => {
                setLoading(false)
                console.log(res)
            }

        )
    }

    useEffect(() => {
        reqAdminOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    const columns = [
        {
            accessorKey: 'user.nama',
            header: 'Nama Admin',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.user?.nip || '-'}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'username',
            header: 'Username',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize='small'
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'password',
            header: 'Password',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize='small'
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'user.jabatan',
            header: 'Jabatan',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize='small'
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'role',
            header: 'Status',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize='small'
                    variant="inherit"
                >
                    {
                        cell.getValue() === 'admin_pembangunan' ? 'Admin Pembangunan' :
                            cell.getValue() === 'admin_pimpinan' ? 'Pimpinan' :
                                cell.getValue() === 'super_admin' && 'Super Admin'
                    }
                </ArgonTypography>
            )
        },
    ];

    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState('')
    const handleAddClick = () => {
        setOpen(true);
        setEditData(null)
    };
    const handleEditClick = (params) => {
        setOpen(true);
        setEditData(params)
        console.log(params);
    };
    const handleClose = () => {
        setOpen(false)
        setEditData(null)
    };

    const deleteData = (username, nama, role) => {
        Swal.fire({
            title: `Hapus Data?`,
            text: `${nama} akan Dihapus`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/sa/users/delete-admin',
                    {
                        _method: 'DELETE',
                        username: username,
                        role: role
                    },
                    decryptedUser,
                    setLoading,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Anggaran OPD</ArgonTypography>
                        }
                        action={
                            <ArgonButton
                                variant='outlined'
                                color="info"
                                size="small"
                                startIcon={<AddCircle />}
                                onClick={handleAddClick}
                            >
                                Tambah Data
                            </ArgonButton>
                        }
                    />
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            // enableExpanding
                            // enableExpandAll
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={true}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='last'
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Action', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'right'
                                }
                            }}
                            renderRowActions={({ row }) => [
                                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }} key={row.original.username}>
                                    <Tooltip title="Edit">
                                        <IconButton
                                            aria-label="edit"
                                            onClick={() => {
                                                handleEditClick(row.original)
                                            }}
                                            color="success">
                                            <Edit color='success' />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Hapus">
                                        <IconButton
                                            aria-label="edit"
                                            onClick={() => {
                                                deleteData(row.original.username, row.original.user.nama, row.original.role)
                                            }}
                                            color="success">
                                            <Delete color='error' />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            ]}
                            enableRowNumbers
                            rowNumberDisplayMode='static'
                        />
                    </CardContent>
                </Card>
            </ArgonBox>
            <Tambah
                open={open}
                handleClose={handleClose}
                decryptedUser={decryptedUser}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
                editData={editData}
            />
        </ArgonBox>
    )
}

export default Admin